/* Keep menu announcements consistent with native details state; do not control navigation. */
(() => {
  const attached = new WeakSet();
  function attach() {
    document.querySelectorAll('[data-section-type="header"] details.site-nav__details').forEach(details => {
      if (attached.has(details)) return;
      const summary = details.querySelector(':scope > summary');
      if (!summary) return;
      attached.add(details);
      const sync = () => {
        const expanded = String(details.open);
        if (summary.getAttribute('aria-expanded') !== expanded) summary.setAttribute('aria-expanded', expanded);
        if (details.getAttribute('aria-expanded') !== expanded) details.setAttribute('aria-expanded', expanded);
      };
      new MutationObserver(sync).observe(details, {
        attributes: true,
        subtree: true,
        attributeFilter: ['open', 'aria-expanded']
      });
      details.addEventListener('toggle', sync);
      sync();
    });
  }
  attach();
  document.addEventListener('shopify:section:load', attach);
})();
